exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}.videoplayer{width:100vw;height:100vh;background-color:#000;margin:auto;overflow:hidden}.videoplayer videogular{width:100%;height:100%}.videoplayer videogular .container{margin:0;padding:0;position:absolute;width:100%;height:.5vh;top:3vh}.videoplayer videogular vg-scrub-bar .container{top:45%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/videoplayer/videoplayer.scss
 ** module id = 96
 ** module chunks = 0
 **/